// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipping-preference[data-v-f2835606]{display:inline-block;margin-right:10px}.preference-content .level-title[data-v-f2835606]{font-weight:700;margin-bottom:10px;color:#333}.preference-content .first-level[data-v-f2835606]{margin-bottom:20px}.preference-content .second-level[data-v-f2835606]{padding-top:10px;border-top:1px solid #eee}", ""]);
// Exports
module.exports = exports;
